import { PageSection } from 'components';
import { useTranslation } from 'react-i18next';
import { HeaderContainer, SubmitButton, Title } from '../../styled';
import EventCardPlate from 'containers/pages/events-list/event-card-plate';
import { EventShort } from 'types/rest';
import { FC } from 'react';
import { SliderContainer } from '../intro/styled';
import Slider, { Settings } from 'react-slick';
import { NewsDesktopContainer } from '../news/styled';
import EventCard from 'containers/pages/events-list/event-card';
import {
    DotsContainer,
    DotsList,
} from 'containers/pages/for-businesses/components/reviews/styled';
import { SliderStyler } from 'containers/pages/for-businesses/components/courses/styled';

const sectionConfig = {
    CWrap: {
        css: {
            paddingBottom: 70,

            '@media(max-width: 1023px)': {
                paddingBottom: 64,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 10,
            '@media(max-width: 1023px)': {
                paddingTop: '0 !important',
                paddingBottom: 0,
            },

            '@media(max-width: 767px)': {
                paddingBottom: 100,
            },
        },
    },
};

type EventsProps = {
    items: EventShort[];
};

export const Events: FC<EventsProps> = ({ items }) => {
    const { t } = useTranslation('pages/academy-alliance');

    const CAROUSEL_SETTINGS: Settings = {
        slidesToScroll: 2,
        infinite: false,
        slidesToShow: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        appendDots:
            items && items.length > 1
                ? (dots) => (
                      <DotsContainer>
                          <DotsList
                              styles={{
                                  '.slick-active': {
                                      background: '#7733FF',
                                      opacity: '1',
                                  },
                                  li: {
                                      opacity: '0.5',
                                      background: '#7733FF',
                                  },
                              }}>
                              {dots}
                          </DotsList>
                      </DotsContainer>
                  )
                : () => <></>,
    };

    return (
        <PageSection config={sectionConfig}>
            <HeaderContainer>
                <Title>{t('events')}</Title>
                <SubmitButton
                    onClick={() => window.open('/events', '_blank')}
                    variant={'outlined'}
                    color={'secondary'}
                    styles={{ bottom: '24px !important' }}>
                    {t('show-all-events')}
                </SubmitButton>
            </HeaderContainer>
            <NewsDesktopContainer>
                <EventCardPlate
                    items={items || []}
                    secondary
                    hasTags
                    target={'_blank'}
                    isAcademy
                />
            </NewsDesktopContainer>

            <SliderContainer>
                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS}>
                        {items.map((item: EventShort) => (
                            <EventCard
                                key={item.id}
                                data={{
                                    imageURL: item.image?.fileLink || '',
                                    title: item.name,
                                    link: `/events/${item.groupName}/`,
                                }}
                                date={item.startDate}
                                isFirstInBlock
                                target={'_blank'}
                                isAcademy
                            />
                        ))}
                    </Slider>
                </SliderStyler>
            </SliderContainer>
        </PageSection>
    );
};
